const MODULE_NAME = 'fulcrum/container/Product/View'
const MOUNT = 'fulcrum/container/Product/View/MOUNT'
const UNMOUNT = 'fulcrum/container/Product/View/UNMOUNT'

const UPDATE_PRODUCT_DETAILS = 'fulcrum/container/Product/View/UPDATE_PRODUCT_DETAILS'
const CLEAR_PRODUCT_DETAILS = 'fulcrum/container/Product/View/CLEAR_PRODUCT_DETAILS'

const FETCH_PRODUCT_DETAILS = 'fulcrum/container/Product/View/FETCH_PRODUCT_DETAILS'
const FETCH_PRODUCT_DETAILS_START = 'fulcrum/container/Product/View/FETCH_PRODUCT_DETAILS_START'
const FETCH_PRODUCT_DETAILS_SUCCESS = 'fulcrum/container/Product/View/FETCH_PRODUCT_DETAILS_SUCCESS'
const FETCH_PRODUCT_DETAILS_ERROR = 'fulcrum/container/Product/View/FETCH_PRODUCT_DETAILS_ERROR'

export {
  MODULE_NAME,
  MOUNT,
  UNMOUNT,
  UPDATE_PRODUCT_DETAILS,
  CLEAR_PRODUCT_DETAILS,
  FETCH_PRODUCT_DETAILS,
  FETCH_PRODUCT_DETAILS_START,
  FETCH_PRODUCT_DETAILS_SUCCESS,
  FETCH_PRODUCT_DETAILS_ERROR,
}
